import React from 'react';
import { connect } from 'react-redux';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import PeopleIcon from '@material-ui/icons/People';
import MeetingRoom from '@material-ui/icons/MeetingRoom';
import ArtTrack from '@material-ui/icons/ArtTrack';
import ThumbUp from '@material-ui/icons/ThumbUp';

import Dashboard from './Dashboard';
import { getList } from '../redux/modules/user/action';
import { getPropertyList } from '../redux/modules/property/action';
import { getPostList } from '../redux/modules/post/action';
import { get_endrosments } from '../redux/modules/endrosment/action';

const styles = (theme) => ({
  card: {
    minWidth: 100,
    marginTop: theme.spacing.unit * 6,
    marginRight: theme.spacing.unit * 2,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    float: 'left',
    display: 'block',
    marginLeft: 10,
    marginTop: 10
  },
  pos: {
    marginBottom: 8,
  },
  fabProgress: {
    color: '#43a047',
    position: 'absolute',
    top: -61,
    left: -6,
    zIndex: 1,
  },
  iconBtn: {
    float: 'left',
    marginBottom: 10
  },
  text: {
    clear: 'both'
  }
});

class Home extends React.Component {
  componentDidMount () {
    const { dispatch } = this.props;
    dispatch(getList());
    dispatch(getPropertyList());
    dispatch(getPostList());
    dispatch(get_endrosments());
  }

  render() {
    const { classes, userList, postList, propertyList, endrosmentList } = this.props;
    const activeUsers = userList.filter(u => u.userDetail && u.userDetail.isActive);
    const inActiveUsers = userList.filter(u => u.userDetail && u.userDetail.isActive === false);
    const inActivePosts = postList.rows ?  postList.rows.filter(u => u.isDeleted) : [];
    const totalPost = postList.count || 0;

    return (
      <Dashboard>
        <Grid container>
          <Grid item xs={12} sm={6} md={3}>
            <Card className={classes.card}>
              <CardContent>
                <Button
                  variant="fab"
                  color="primary"
                  className={classes.iconBtn}
                >
                  <PeopleIcon />
                </Button>                
                <Typography variant="h5" component="h2" className={classes.title}>
                  Users
                </Typography>
                <p className={classes.text}>
                  <Typography className={classes.pos} color="textSecondary">
                    Total: {userList.length}
                  </Typography>
                  <Typography className={classes.pos} color="textSecondary">
                    Active: {activeUsers.length}
                  </Typography>
                  <Typography className={classes.pos} color="textSecondary">
                    InActive: {inActiveUsers.length}
                  </Typography>
                </p>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card className={classes.card}>
              <CardContent>
                <Button
                  variant="fab"
                  color="primary"
                  className={classes.iconBtn}
                >
                  <ArtTrack />
                </Button>                
                <Typography variant="h5" component="h2" className={classes.title}>
                  Posts
                </Typography>
                <p className={classes.text}>
                  <Typography className={classes.pos} color="textSecondary">
                    Total: {totalPost}
                  </Typography>
                  <Typography className={classes.pos} color="textSecondary">
                    Active: {totalPost - inActivePosts.length}
                  </Typography>
                  <Typography className={classes.pos} color="textSecondary">
                    InActive: {inActivePosts.length}
                  </Typography>
                </p>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card className={classes.card}>
              <CardContent>
                <Button
                  variant="fab"
                  color="primary"
                  className={classes.iconBtn}
                >
                  <MeetingRoom />
                </Button>                
                <Typography variant="h5" component="h2" className={classes.title}>
                  Properties
                </Typography>
                <p className={classes.text}>
                  <Typography className={classes.pos} color="textSecondary">
                    Total: {propertyList.count}
                  </Typography>
                </p>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card className={classes.card}>
              <CardContent>
                <Button
                  variant="fab"
                  color="primary"
                  className={classes.iconBtn}
                >
                  <ThumbUp />
                </Button>                
                <Typography variant="h5" component="h2" className={classes.title}>
                  Endrosments
                </Typography>
                <p className={classes.text}>
                  <Typography className={classes.pos} color="textSecondary">
                    Total: {endrosmentList.length}
                  </Typography>
                </p>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Dashboard>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    userList: state.user.list,
    postList: state.post.list,
    propertyList: state.property.list,
    endrosmentList: state.endrosment.list
  })
}

export default connect(mapStateToProps)(withStyles(styles)(Home));